import React from 'react'
import Icon from '~/Common-Objects/UI/Icon'
import styles from './index.module.scss'

const EmptyState = ({ icon, title, description }) => {
    return (
        <div className={styles.root}>
            {icon && <Icon type={icon} className={styles.icon} />}
            <h3 className={styles.title}>{title}</h3>
            {description && <div className={styles.description}>{description}</div>}
        </div>
    )
}

export default EmptyState
